import styled from "styled-components"

const Any = styled.div`
    font-size: 18px;
    white-space: nowrap;
`

export default Any